import type { TransportOperationName } from "@/types_api/backend/transport/operations"

/**
 * Resource records embed tag names by value, so a rename leaves every cached
 * record holding the previous name until it is refetched. Detail readers hold
 * the name just as list readers do, so a mounted detail page needs the same
 * refresh as the list it was opened from.
 */
export const TAGGED_RESOURCE_OPERATIONS = [
  "getAgent",
  "getMetric",
  "getMultiRunMetadata",
  "getPersona",
  "getRunMetadata",
  "getRunTemplate",
  "listAgents",
  "listAllAgents",
  "listMetrics",
  "listPersonas",
  "listSimulatedConversationsKeyset",
  "listRunTemplates",
  "listRunsKeyset",
  "listTestSets",
  "queryUploadedConversationKeyset",
  "testSetMetadata",
] as const satisfies readonly TransportOperationName[]
